"use client";

import { useState } from "react";
import type { Params } from "@/types";

const useParams = () => {
  const formParams: Params = {
    search: "",
    limit: 10,
    order_by: "id",
    order_direction: "asc",
    per_page: 10,
    current_page: 1,
    without_pagination: 0,
    filter: {},
  };

  const [params, setParams] = useState<Params>(formParams);

  const handlePage = (value: string | number) => {
    if (value === "prev") {
      prevPage();
    } else if (value === "next") {
      nextPage();
    } else {
      setParams((prev) => ({
        ...prev,
        current_page: value as number,
      }));
    }
  };

  const nextPage = () => {
    setParams((prev) => ({
      ...prev,
      current_page: prev.current_page! + 1,
    }));
  };

  const prevPage = () => {
    setParams((prev) => ({
      ...prev,
      current_page: prev.current_page! - 1,
    }));
  };

  const updateParams = (newParams: Partial<Params>) => {
    setParams((prev) => ({
      ...prev,
      ...newParams,
    }));
  };

  return { params, setParams, handlePage, updateParams };
};

export default useParams;
